import React, { useEffect } from 'react';
import { Controller, ControllerProps, useFormContext } from 'react-hook-form';
import TextField, { ITextField } from './TextField';

type ControlledTextFieldProps = Omit<ITextField, 'name'> & {
  name: string;
  rules?: ControllerProps['rules'];
};

export const ControlledTextField: React.FC<ControlledTextFieldProps> = ({
  rules,
  ...props
}) => {
  const { control, clearErrors } = useFormContext();

  useEffect(() => {
    return () => {
      clearErrors(props.name);
    };
  }, [clearErrors, props.name]);

  return (
    <Controller
      name={props.name}
      defaultValue=""
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return <TextField errorMsg={error?.message} {...field} {...props} />;
      }}
    />
  );
};
